const HOSTNAME = process.env.NODE_ENV === 'test' ? 'https://babylist.test' : ''

export default HOSTNAME
